import { render } from "./CarousalComponent.vue?vue&type=template&id=07a65a03"
import script from "./CarousalComponent.vue?vue&type=script&lang=js"
export * from "./CarousalComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__